import { Link } from 'react-router-dom';
import { publicHome } from '@/i18n/dictionaries/publicHome';
import { useTranslation } from '@/i18n/useTranslation';

/** The funding call-to-action band, with the subscribe panel beside it. */
export function HomeFunding() {
  const { t } = useTranslation(publicHome);

  return (
    <section className="section">
      <div className="container">
        <div className="cta-band">
          <div>
            <span className="eyebrow">{t('ctaEyebrow')}</span>
            <h2>{t('ctaHeading')}</h2>
            <p>{t('ctaLead')}</p>
            <div className="cta-band__actions">
              <Link className="btn btn--white btn--lg" to="/finantare">
                {t('ctaOpenCalls')}
              </Link>
              <Link className="btn btn--white-outline" to="/finantare">
                {t('ctaGuides')}
              </Link>
            </div>
          </div>
          <div className="cta-subscribe">
            <h3>{t('ctaSubscribeHeading')}</h3>
            <p>{t('ctaSubscribeLead')}</p>
            <div className="cta-subscribe__row">
              <a
                className="btn btn--white btn--md cta-subscribe__button"
                href="/saml/authenticate/mpass"
              >
                {t('ctaSubscribeButton')}
              </a>
            </div>
            <small>{t('ctaSubscribeSmall')}</small>
          </div>
        </div>
      </div>
    </section>
  );
}
